<template>
  <v-hover style="width:300px;" class="zoom">
    <router-link :to="routerLinkTo">
      <v-card
        @mouseover="hover = true & changeBackgroundColor(color, imageUrl)"
        max-width="344"
        class="mx-auto"
      >
        <v-fade-transition>
          <v-overlay v-if="hover" absolute :color="color">
            <v-btn>Les mer</v-btn>
          </v-overlay>
        </v-fade-transition>

        <v-list-item>
          <v-list-item-avatar :color="color">
            <v-icon>
              {{logo}}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline">{{title}}</v-list-item-title>
            <v-list-item-subtitle>{{shortDescription}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </router-link>
  </v-hover>
</template>

<script>
export default {
  props: ["routerLinkTo", "color", "title", "shortDescription", "imageUrl", "logo"],

  mounted() {
    this.changeBackgroundColor("black", "pretty-sky.png");
  },

  methods: {
    async changeBackgroundColor(color, imageUrl) {
      const content = document.getElementById("content");
      content.style.backgroundColor = "black";
      const image = require("@/assets/background-images/" + imageUrl);
      content.style.backgroundImage = `url(${image})`;
    }
  },

  data() {
    return {
      hover: false
    };
  }
};
</script>

<style>
a {
  text-decoration: none;
}

.zoom {
  margin: 2rem;
  transition: transform 0.2s; /* Animation */
  display: inline-block;
}

.zoom:hover {
  transform: scale(
    1.2
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
</style>